import { render } from "./TheConfigurator.vue?vue&type=template&id=6bfd6a95&scoped=true"
import script from "./TheConfigurator.vue?vue&type=script&lang=js"
export * from "./TheConfigurator.vue?vue&type=script&lang=js"

import "./TheConfigurator.vue?vue&type=style&index=0&id=6bfd6a95&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfd6a95"]])

export default __exports__